/* @flow */
import React from 'react';
import cx from 'classnames';

import Button from 'components/Button.jsx';
import ChatParticipantSearchMixin from 'components/mixins/ChatParticipantSearchMixin';
import Glyph from 'components/Glyph.jsx';
import Group from 'entities/Group';
import GroupInviteModal from 'groups/components/GroupInviteModal.jsx';
import ModalTrigger from 'components/ModalTrigger.jsx';
import { mountModal } from 'lib/modal';
import TooltipTrigger from 'components/TooltipTrigger.jsx';

import './styles/InviteButton.scss';

const InviteButton = React.createClass({
  propTypes: {
    group: React.PropTypes.instanceOf(Group).isRequired,
    forceType: React.PropTypes.oneOf(['button', 'glyph']),
  },

  mixins: [
    ChatParticipantSearchMixin,
  ],

  handleGroupSelect(group: Group) {
    this.refs.groupSelectionDialog.hide();
    const modal = <GroupInviteModal group={group} />;
    mountModal(modal, this);
  },

  canInvite() {
    const { group } = this.props;
    return (group.isRoot() || group.canAddPeople());
  },

  renderModal() {
    const { group } = this.props;

    if (group.isRoot()) {
      return this.renderGroupSelectionDialog();
    }
    return <GroupInviteModal group={group} />;
  },

  renderButton(className: string, text: string) {
    return (
      <Button
        size="small"
        eventElementName="add_people"
        {...this.props}
        className={cx(this.props.className, className)}>
        {text}
      </Button>
    );
  },

  renderGlyph(className: string, text: string) {
    return (
      <TooltipTrigger tooltip={text} placement="bottom">
        <Button
          {...this.props}
          eventElementName="add_people"
          full={false}
          size="small"
          level="icon"
          className={className}
          data-test-selector="invite_button">
          <Glyph name="avatar-add" size="large" color="brand" solo />
        </Button>
      </TooltipTrigger>
    );
  },

  render() {
    if (!this.canInvite()) {
      return null;
    }

    const text = 'Add people';
    let trigger;

    if (this.props.forceType === 'button') {
      trigger = (
        <div style={{ display: 'inline' }}>
          {this.renderButton('InviteButton-alwaysButton', text)}
        </div>
      );
    } else if (this.props.forceType === 'glyph') {
      trigger = (
        <div style={{ display: 'inline' }}>
          {this.renderGlyph('InviteButton-alwaysGlyph', text)}
        </div>
      );
    } else {
      trigger = (
        <div style={{ display: 'inline' }}>
          {this.renderGlyph('InviteButton-small', text)}
          {this.renderButton('InviteButton-big', text)}
        </div>
      );
    }

    return (
      <ModalTrigger modal={this.renderModal()}>
        {trigger}
      </ModalTrigger>
    );
  },
});

export default InviteButton;



// WEBPACK FOOTER //
// ./src/users/components/InviteButton.jsx